import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          kicker="Categories"
          title="按栏目找乐子"
          description="同一次事故往往同时包含翻车、尴尬和搞笑三重属性，我们按最突出的那一面归类，方便你直接找到想看的类型。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className={`group relative flex min-h-[220px] flex-col justify-end overflow-hidden rounded-lg border border-background-200 p-5 transition-colors hover:border-primary-300 ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <img
                src={category.cover}
                alt={`${category.name}栏目配图`}
                className="absolute inset-0 h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10" />
              <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${category.icon} text-lg`} />
              </span>
              <div className="relative mt-4">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-bold text-background-50">
                    {category.name}
                  </h3>
                  <span className="rounded-full bg-background-50/20 px-2 py-0.5 text-xs text-background-100">
                    {category.count} 篇
                  </span>
                </div>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-background-200">
                  {category.slogan}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}